import { Injectable } from '@angular/core';

interface DataTableApiWithResponsive extends DataTables.Api {
  responsive?: {
    recalc: () => void;
  };
}

@Injectable({
  providedIn: 'root'
})
export class DataTableManagerService {
  init(selector: string, options?: DataTables.Settings): DataTables.Api | null {
    if (!$(selector).length) {
      return null;
    }

    const language: DataTables.LanguageSettings = {
      url: 'assets/DataTable/pt-BR.json',
      emptyTable: 'Nenhum registro encontrado.',
      zeroRecords: 'Nenhum registro encontrado.',
      ...options?.language
    };

    return $(selector).DataTable({
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true,
      order: [[0, 'asc']],
      ...options,
      language
    });
  }

  destroy(dataTable?: DataTables.Api): void {
    if (dataTable) {
      dataTable.destroy();
    }
  }

  adjust(dataTable?: DataTables.Api): void {
    if (!dataTable) {
      return;
    }

    dataTable.columns.adjust();
    (dataTable as DataTableApiWithResponsive).responsive?.recalc();
  }
}
